exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html,\nbody {\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  color: rgba(0, 0, 0, 0.5); }\n\n#root {\n  height: 100%; }\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: 'Lato', sans-serif;\n  background-color: rgba(240, 240, 240, 0.2); }\n\nbutton {\n  border: none;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n  background-color: transparent; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/index.scss
// module id = 48
// module chunks = 0